import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetInvoice } from 'api/invoices/use-get-invoice.ts';
import type { ClientRes } from 'api/swagger';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { ECommentEntityName } from 'types/comment.ts';
import { ClientInfoCard } from 'components/clients/client-info-card';
import { CommentsCard } from 'components/comments/comments-card';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { InvoiceInfoCard } from 'components/invoices/invoice-info-card';
import { InvoicePageHeader } from 'components/invoices/invoice-page-header';

export const InvoicePageComponent: React.FC = () => {
  const { invoiceId } = useParams();

  const { data: invoice, isLoading } = useGetInvoice(Number(invoiceId));

  return (
    <DefaultPageLayout header={!isLoading && invoice ? <InvoicePageHeader invoice={invoice} /> : undefined}>
      {!isLoading && invoice ? (
        <>
          <Row gutter={16}>
            <Col span={17}>
              <Card style={{ width: '100%' }}>
                <DocumentsUpload invoiceId={invoice.id} />
                <DocumentsList invoiceId={invoice.id} />
              </Card>
            </Col>
            <Col span={7}>
              <Flex gap='middle' vertical>
                <InvoiceInfoCard invoice={invoice} client={invoice.client as ClientRes} />
                <ClientInfoCard client={invoice.client as ClientRes} contact={invoice.contact} />
                <CommentsCard entityName={ECommentEntityName.invoice} entityId={invoice.id} />
              </Flex>
            </Col>
          </Row>
        </>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};

export const InvoicePage = withRoleGuard(InvoicePageComponent, [
  UserRole.assistant,
  UserRole.admin,
  UserRole.accountant,
]);
